
















































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { IMenuItem, IMenuLink } from ".";
import ThirdLevelMenu from "./_ThirdLevelMenu.vue";

@Component({
    components: {
        ThirdLevelMenu,
    },
})
export default class SecondLevelMenuItem extends Vue {
    private showThirdLevel: boolean = false;
    @Prop({ default: () => [] }) public itemData: IMenuItem[];

    public toggleThirdLevelMenu(): void {
        if (this.showThirdLevel === true) {
            // If you're clicking the currently open third level, close it
            this.showThirdLevel = !this.showThirdLevel;
            return;
        } else {
            // close all the other third levels and open this one
            this.$emit("reset-third-levels");
            this.showThirdLevel = !this.showThirdLevel;
        }
    }

    public closeThirdLevelMenu(): void {
        this.showThirdLevel = false;
    }

    additionalClassesForItem(item: IMenuLink){
        return {
            ['sip-modal']: !!item?.modal,
            ['sip-link']: !!item,
        }
    }

    navigateAction(e: Event, item: IMenuLink) {
        if (!!item?.modal) {
            e.preventDefault();
            this.navigate(e);
        }
    }

    @Emit('navigate') public navigate(e: Event) { return e; }
}
